"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importDefault(require("swiper"));
const element_toggler_1 = __importDefault(require("../../../../scripts/element-toggler"));
const helpers_1 = require("../../../../scripts/helpers");
const sticky_scroll_1 = __importDefault(require("../../../../scripts/sticky-scroll"));
const modules_1 = require("swiper/modules");
const collapsible_section_1 = __importDefault(require("../../ui/collapsible-section/collapsible-section"));
const initProductsCatalog = ($products, $header) => {
    let countFilters = 0;
    // Использование
    const $catalogContainer = $products.querySelector('.products-catalog__left');
    const $stickySidebar = $catalogContainer === null || $catalogContainer === void 0 ? void 0 : $catalogContainer.querySelector('.products-catalog__left-sticky');
    const $catalogContent = $products.querySelector('.products-catalog__right');
    const $openFilterButton = $products.querySelector('.products-catalog__fiters-button');
    const $closeMobFilterButton = $products.querySelector('.products-catalog__filters-header-back-button');
    const $showResultsFilterButton = $products.querySelector('.products-catalog__filters-show-button');
    const $resultsBtn = $products.querySelector('.products-catalog__show-results');
    const $showResultsMobFilterButton = $products.querySelector('.products-catalog__filters-footer-button');
    const $clearMobFilterButton = $products.querySelector('.products-catalog__filters-header-clear-button');
    const $selectedFilters = $products.querySelector('.selected-filters');
    const $categoryTagsSlider = $products.querySelector('.products-catalog__tags-slider');
    const $filtersLinksList = $catalogContainer.querySelector('.products-catalog__filters-links-list');
    const $underHeaderText = document.querySelector('.products-catalog__under-header-text');
    if ($catalogContainer && $stickySidebar && $catalogContent) {
        if (window.innerWidth > 991)
            (0, sticky_scroll_1.default)($catalogContainer, $stickySidebar, $catalogContent);
        if ($openFilterButton) {
            (0, element_toggler_1.default)({
                $element: $catalogContainer,
                openTrigger: $openFilterButton,
                closeTrigger: [$closeMobFilterButton, $clearMobFilterButton],
                onBeforeOpen: () => {
                    $header.style.zIndex = '1';
                },
                onBeforeClose: () => {
                    $header.style.zIndex = '';
                },
            });
        }
    }
    if ($underHeaderText)
        new collapsible_section_1.default($underHeaderText.querySelector('.collapsible-section'));
    /* обработка перемещения баннера */
    const $catalogBanner = $products.querySelector('.products-catalog__banner');
    if ($catalogBanner) {
        const catalogCards = $products.getElementsByClassName('products-catalog__card');
        handlerTransitionBanner();
        window.addEventListener('resize', (0, helpers_1.debounce)(handlerTransitionBanner, 50));
        function handlerTransitionBanner() {
            if (window.innerWidth < 1600) {
                for (const i in catalogCards) {
                    if (Number(i) + 1 === 8) {
                        catalogCards[i].insertAdjacentElement('afterend', $catalogBanner);
                        return;
                    }
                }
            }
            else {
                for (const i in catalogCards) {
                    if (Number(i) + 1 === 10) {
                        catalogCards[i].insertAdjacentElement('afterend', $catalogBanner);
                        return;
                    }
                }
            }
        }
    }
    /* initLogic */
    const initLogic = () => {
        var _a;
        const showLoaderResultsBtn = ($button) => {
            $button.setAttribute('tabindex', '-1');
            $button.style.pointerEvents = 'none';
            $button.querySelector('[data-loader]').style.opacity = '1';
        };
        const hideLoaderResultsBtn = ($button) => {
            $button.setAttribute('tabindex', '0');
            $button.style.pointerEvents = '';
            $button.querySelector('[data-loader]').style.opacity = '0';
        };
        const showResultsBtn = () => {
            $resultsBtn.style.pointerEvents = '';
            $resultsBtn.style.opacity = '1';
            setTimeout(() => {
                $resultsBtn.setAttribute('tabindex', '0');
            }, 100);
        };
        const hideResultsBtn = () => {
            $resultsBtn.style.pointerEvents = 'none';
            $resultsBtn.style.opacity = '0';
            setTimeout(() => {
                $resultsBtn.setAttribute('tabindex', '-1');
            }, 100);
        };
        const moveResultsBtnToAccordionInput = ($accordion, $input = false) => {
            // Проверяем, находится ли кнопка уже в аккордеоне
            const currentOffsetTop = $resultsBtn.offsetTop;
            const $accordionBody = $accordion.querySelector('.accordion__body');
            const $inputWrapper = $input ? (0, helpers_1.closest)($input, '.checkbox__wrapper') : null;
            const neededOffsetTop = $accordionBody.offsetTop + ($input ? $inputWrapper.offsetTop + $inputWrapper.offsetHeight / 2 : 0);
            // Устанавливаем начальные стили для анимации
            $resultsBtn.style.transform = `translateX(100%) translateY(${neededOffsetTop - currentOffsetTop}px)`; // Сохраняем translateX из вашего кода
        };
        const setNewDateToResultsBtn = ($link, count, url) => {
            $link.querySelector('[data-count]').textContent =
                `Показать ${count} товар${count % 10 === 1 && count % 100 !== 11 ? '' : count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20) ? 'а' : 'ов'}`;
            $link.href = url;
        };
        const $productsCatalogFilters = $products.querySelector('.products-catalog__filters');
        let sendDataProductsCatalogFilters;
        if ($productsCatalogFilters) {
            const action = $productsCatalogFilters.getAttribute('action');
            $productsCatalogFilters.addEventListener('submit', e => {
                e.preventDefault();
            }, { passive: false });
            sendDataProductsCatalogFilters = (options) => __awaiter(void 0, void 0, void 0, function* () {
                [$resultsBtn, $showResultsFilterButton, $showResultsMobFilterButton].forEach(showLoaderResultsBtn);
                const queryString = (0, helpers_1.serializeToSearchString)($productsCatalogFilters);
                let url;
                if (action.includes('?')) {
                    url = `${action}&${queryString}`;
                }
                else {
                    url = `${action}?${queryString}`;
                }
                const responseBody = yield fetch(url, {
                    method: 'GET',
                }).then(res => res.json());
                if (responseBody['success']) {
                    if (options === null || options === void 0 ? void 0 : options.redirectToUrl)
                        window.location.href = responseBody.url;
                    [$resultsBtn, $showResultsFilterButton, $showResultsMobFilterButton].forEach(($link) => setNewDateToResultsBtn($link, responseBody.count, responseBody.url));
                }
                [$resultsBtn, $showResultsFilterButton, $showResultsMobFilterButton].forEach(hideLoaderResultsBtn);
            });
            /* Инициализируем все блоки инпутов */
            $productsCatalogFilters.querySelectorAll('bm-accordion').forEach(($accordion) => {
                const $priceFilterSlider = $accordion.querySelector('.price-filter-slider');
                const $checkboxList = $accordion.querySelector('.products-catalog__filters-checkboxes-list');
                if ($priceFilterSlider) {
                    const $inputMin = $priceFilterSlider.querySelector('.price-filter-slider__input-min .input');
                    const $inputMax = $priceFilterSlider.querySelector('.price-filter-slider__input-max .input');
                    const $inputsContainer = $priceFilterSlider.querySelector('.price-filter-slider__inputs-container');
                    // Store initial values
                    $inputMin.lastValue = $inputMin.value || $inputsContainer.dataset.min || '0';
                    $inputMax.lastValue = $inputMax.value || $inputsContainer.dataset.max || '0';
                    let countFilters = 0;
                    /**
                     * Обработчик изменения диапазона.
                     *
                     * @async
                     *
                     * @returns {Promise<void>} Promise, который разрешается после завершения обработки.
                     */
                    const rangeChangeHandler = () => __awaiter(void 0, void 0, void 0, function* () {
                        // Get current values and ensure they're numbers
                        const currentMin = parseFloat($inputMin.value) || parseFloat($inputsContainer.dataset.min) || 0;
                        const currentMax = parseFloat($inputMax.value) || parseFloat($inputsContainer.dataset.max) || 0;
                        const lastMin = parseFloat($inputMin.lastValue) || 0;
                        const lastMax = parseFloat($inputMax.lastValue) || 0;
                        // Validate and correct values
                        const minLimit = parseFloat($inputsContainer.dataset.min) || 0;
                        const maxLimit = parseFloat($inputsContainer.dataset.max) || 0;
                        // Корректируем значения
                        let newMin = currentMin;
                        let newMax = currentMax;
                        if (newMin > newMax) {
                            newMin = newMax;
                        }
                        if (newMin < minLimit) {
                            newMin = minLimit;
                        }
                        if (newMax > maxLimit) {
                            newMax = maxLimit;
                        }
                        // Обновляем значения в инпутах
                        $inputMin.value = String(newMin);
                        $inputMax.value = String(newMax);
                        // Проверяем, изменились ли значения
                        if (lastMin !== newMin || lastMax !== newMax) {
                            countFilters++;
                            moveResultsBtnToAccordionInput($accordion);
                            showResultsBtn();
                            yield sendDataProductsCatalogFilters({});
                            // Обновляем последние значения
                            $inputMin.lastValue = String(newMin);
                            $inputMax.lastValue = String(newMax);
                        }
                        else {
                            if (countFilters === 0) {
                                hideResultsBtn();
                            }
                        }
                    });
                    /**
                     * Функция обертки для обработчика изменения диапазона с использованием debounce.
                     *
                     * @returns {Function} Функция-обертка с применением debounce.
                     */
                    // const debouncedRangeChangeHandler = debounce(rangeChangeHandler, 3000);
                    // Add event listeners
                    // $inputMin.addEventListener('input', debouncedRangeChangeHandler);
                    // $inputMax.addEventListener('input', debouncedRangeChangeHandler);
                    $inputMin.addEventListener('change', rangeChangeHandler); // Немедленное обновление при потере фокуса
                    $inputMax.addEventListener('change', rangeChangeHandler); // Немедленное обновление при потере фокуса
                }
                else if ($checkboxList) {
                    $checkboxList
                        .querySelectorAll('input[type="checkbox"]')
                        .forEach(($checkbox) => __awaiter(void 0, void 0, void 0, function* () {
                        $checkbox.lastValue = $checkbox.checked;
                        $checkbox.addEventListener('change', (e) => __awaiter(void 0, void 0, void 0, function* () {
                            moveResultsBtnToAccordionInput($accordion, $checkbox);
                            showResultsBtn();
                            yield sendDataProductsCatalogFilters({});
                            if ($checkbox.lastValue != $checkbox.checked) {
                                countFilters++;
                            }
                            else {
                                if (--countFilters == 0) {
                                    hideResultsBtn();
                                }
                            }
                        }));
                    }));
                }
            });
            // Очищает фильтры
            const resetFilters = () => {
                hideSelectedFilters();
                $selectedFilters === null || $selectedFilters === void 0 ? void 0 : $selectedFilters.querySelectorAll('.selected-filters__item').forEach($item => {
                    removeFilter($item.getAttribute('data-id-filter'), false);
                });
            };
            const hideSelectedFilters = () => {
                $selectedFilters.style.display = 'none';
            };
            const removeFilter = (idFilter, dispatchEventOnCheckbox = true) => {
                const $checkbox = $productsCatalogFilters.querySelector(`#${idFilter}`);
                if ($checkbox) {
                    $checkbox.checked = false;
                    if (dispatchEventOnCheckbox)
                        $checkbox.dispatchEvent(new Event('change'));
                }
                // $selectedFilters
                //   ?.querySelector(`[data-id-filter="${idFilter}"]`)
                //   .parentElement.remove();
                if (($selectedFilters === null || $selectedFilters === void 0 ? void 0 : $selectedFilters.querySelectorAll('.swiper-slide').length) == 0)
                    hideSelectedFilters();
            };
            // Вешаем обработчики событий на уже выбранные фильтры в слайдере
            $selectedFilters === null || $selectedFilters === void 0 ? void 0 : $selectedFilters.querySelectorAll('.selected-filters__item').forEach($item => {
                const idFilter = $item.getAttribute('data-id-filter');
                $item.querySelector('.selected-filters__item-button-close').addEventListener('click', () => {
                    $item.parentElement.remove();
                    removeFilter(idFilter, false);
                    sendDataProductsCatalogFilters({
                        redirectToUrl: true,
                    });
                });
            });
            /* Вешаем обработчики событий на кнопку очистки выбранных фильтров в слайдере */
            (_a = $selectedFilters === null || $selectedFilters === void 0 ? void 0 : $selectedFilters.querySelector('.selected-filters__clear-button')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                resetFilters();
                sendDataProductsCatalogFilters({
                    redirectToUrl: true,
                });
            });
        }
    };
    initLogic();
    if ($selectedFilters) {
        new swiper_1.default($selectedFilters.querySelector('.swiper'), {
            slidesPerView: 'auto',
            modules: [modules_1.Navigation],
            watchSlidesProgress: true,
            allowTouchMove: true,
            loop: false,
            navigation: {
                nextEl: $selectedFilters.querySelector('.slider__button-next'),
                prevEl: $selectedFilters.querySelector('.slider__button-prev'),
            },
        });
    }
    if ($categoryTagsSlider) {
        new swiper_1.default($categoryTagsSlider.querySelector('.swiper'), {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            allowTouchMove: true,
            loop: false,
        });
    }
    if ($filtersLinksList) {
        const $collapsibleSection = $filtersLinksList.querySelector('.collapsible-section');
        if ($collapsibleSection)
            new collapsible_section_1.default($collapsibleSection);
    }
};
exports.default = initProductsCatalog;
